module.exports = __webpack_public_path__ + "img/legal.e19478ca.svg";